// extracted by mini-css-extract-plugin
export default {"text":"Home_text__Tkuko"};